/* ==========================================================================
   Naar Halı — kurumsal sayfa iyileştirmeleri  (28 Ağu 2026)

   Sayfa içerikleri temada değil Shopify admin'de tutuluyor ve yasal sayfaların
   HTML'i Word / eski İkas editöründen yapıştırılmış. Bu dosya o içeriği
   tarayıcıda okunur hâle getiriyor. Metnin KELİMELERİ hiç değişmiyor —
   yalnız boş düğümler siliniyor, başlık seviyeleri geri kazanılıyor ve
   tablolar kaydırılabilir kutuya alınıyor.

   Yaptıkları:
     1. Boş <p>/<div> temizliği   (kocaman dikey boşlukların sebebi)
     2. Sayfa başlığının içerikte tekrarlanan kopyasını kaldırma
     3. Başlık gibi yazılmış paragrafları <h2>'ye yükseltme  (yalnız belge)
     4. Tabloları yatay kaydırılabilir sarmalayıcıya alma
     5. Kırık / yer tutucu görselleri işaretleme
     6. İçindekiler + okuma takibi
     7. Bilgi düzeninde başlık gruplarını karta çevirme
     8. IBAN'lara kopyala düğmesi

   Bölüm ayarları data-* nitelikleriyle geliyor (sections/main-page.liquid).
   ========================================================================== */

(function () {
  'use strict';

  var MAX_BASLIK_UZUNLUK = 80;
  var MIN_HARF = 8;
  var MAX_YUKSELTME = 40;

  /* Word cikitisi gorunmez bosluklarla dolu: &nbsp;, zero-width space,
     word-joiner. Hepsi normal bosluga cevrilip kirpiliyor. */
  function metin(el) {
    return (el.textContent || '')
      .replace(/[ ​‌‍﻿]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function bosMu(el) {
    if (el.querySelector('img, table, iframe, video, svg, input, hr')) return false;
    return metin(el) === '';
  }

  /* Türkçe karakterleri koruyan slug — id ve #bağlantı için */
  function slug(s) {
    var harita = { ç: 'c', ğ: 'g', ı: 'i', İ: 'i', ö: 'o', ş: 's', ü: 'u' };
    return s
      .toLocaleLowerCase('tr-TR')
      .replace(/[çğıİöşü]/g, function (k) { return harita[k] || k; })
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'bolum';
  }

  function harfSayisi(s) {
    var m = s.match(/[\p{L}]/gu);
    return m ? m.length : 0;
  }

  /* Bir paragraf başlık gibi mi yazılmış?
     Ölçüt: kısa + tamamı büyük harf + en az 8 harf + (boşluk içeriyor veya
     rakamla başlıyor). "ADRES:", "TEL:", "ŞİRKET" gibi form etiketleri bu
     eşiğin altında kaldığı için başlığa dönüşmüyor. */
  function baslikGibiMi(t) {
    if (!t || t.length > MAX_BASLIK_UZUNLUK) return false;
    if (t !== t.toLocaleUpperCase('tr-TR')) return false;
    var harf = harfSayisi(t);
    var rakamlaBasliyor = /^\d+\s*[.)]/.test(t);
    if (rakamlaBasliyor) return harf >= 4;
    return harf >= MIN_HARF && /\s/.test(t);
  }

  /* ---------------------------------------------------------------- 1 + 2 */

  function temizle(icerik, sayfaBasligi) {
    /* Word'un <o:p> gibi ad alanli etiketleri ve tamamen bosalmis sarmalayicilar.
       Icerik agacinda derinden yuzeye dogru gidiliyor: bir kap ancak icindeki
       her sey silindikten sonra bos sayilabilir. querySelectorAll belge
       sirasinda dondugu icin tersten yurumek bu sirayi veriyor. */
    var SILINEBILIR = 'p, div, span, font, b, strong, em, i, u, h1, h2, h3, h4, h5, h6, section, article';
    for (var tur = 0; tur < 2; tur++) {
      var hepsi = Array.prototype.slice.call(icerik.querySelectorAll(SILINEBILIR));
      // Ad alanli etiketler (<o:p>) CSS seciciyle guvenilir yakalanamiyor
      Array.prototype.forEach.call(icerik.querySelectorAll('*'), function (el) {
        if (el.tagName.indexOf(':') !== -1) hepsi.push(el);
      });
      for (var i = hepsi.length - 1; i >= 0; i--) {
        if (hepsi[i].parentNode && bosMu(hepsi[i])) hepsi[i].remove();
      }
    }

    /* Tamamen bos tablo satirlari - Word tablolarinda ayirici olarak
       birakiliyor, cerceveli tabloda bos bir seride donusuyor. */
    icerik.querySelectorAll('tr').forEach(function (tr) {
      var hucreler = tr.querySelectorAll('td, th');
      if (!hucreler.length) return;
      for (var k = 0; k < hucreler.length; k++) {
        if (!bosMu(hucreler[k])) return;
      }
      tr.remove();
    });

    kopyaBasligiKaldir(icerik, sayfaBasligi);
  }

  /* Sayfa adinin icerik icinde tekrarlanan kopyasi.
     Iki kez cagriliyor: temizlikten hemen sonra ve basliklar <h2>'ye
     yukseltildikten sonra. Yukseltme oncesinde kopya bir <div> sarmalayicinin
     icinde gomulu olabiliyor (mesafeli satis sozlesmesinde oyleydi) ve
     bulunamiyor. */
  function kopyaBasligiKaldir(icerik, sayfaBasligi) {
    if (!sayfaBasligi) return;
    var hedef = sayfaBasligi.toLocaleLowerCase('tr-TR').replace(/\s+/g, '');

    function ayniMi(el) {
      var t = metin(el).toLocaleLowerCase('tr-TR').replace(/\s+/g, '');
      if (!t || t.length > 90) return false;
      if (t === hedef) return true;
      // Yalnizca birkac kelimelik ek varsa kopya say: "Iletisim" sayfasinda
      // "Iletisim formunu doldurun..." diye baslayan gercek bir paragrafi
      // silmemek icin fark 25 karakterle sinirli.
      return t.indexOf(hedef) === 0 && t.length <= hedef.length + 25;
    }

    var adaylar = Array.prototype.slice.call(icerik.children, 0, 3);
    for (var j = 0; j < adaylar.length; j++) {
      if (ayniMi(adaylar[j])) {
        adaylar[j].remove();
        return;
      }
    }

    // Kopya ic ice sarilmis olabilir; ilk basligi da denetle.
    var ilkBaslik = icerik.querySelector('h1, h2');
    if (ilkBaslik && ayniMi(ilkBaslik)) {
      var kap = ilkBaslik.parentNode;
      ilkBaslik.remove();
      if (kap && kap !== icerik && bosMu(kap)) kap.remove();
    }
  }

  /* Zararli satir ici bildirimler. Word ve eski Ikas editoru her elemente
     sabit genislik, punto, renk ve 30px'lik ic bosluk yaziyor; olcum:
     div.content -> padding: 30px, h2 -> font-size: 25px; margin: 0 0 6pt.
     font-weight / font-style / text-decoration KORUNUYOR - sozlesme
     metninde kalin yazilmis madde basliklari anlam tasiyor. */
  var ZARARLI = [
    'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height',
    'padding', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
    'font', 'font-family', 'font-size', 'line-height', 'letter-spacing', 'word-spacing',
    'color', 'background', 'background-color', 'background-image',
    'border', 'border-top', 'border-right', 'border-bottom', 'border-left',
    'border-width', 'border-radius', 'box-shadow', 'outline',
    'text-indent', 'position', 'top', 'left', 'right', 'bottom', 'float', 'transform'
  ];

  function stilleriAyikla(icerik) {
    icerik.querySelectorAll('[style]').forEach(function (el) {
      if (el.style.textAlign === 'justify') el.style.textAlign = '';
      for (var i = 0; i < ZARARLI.length; i++) el.style.removeProperty(ZARARLI[i]);
      if (!el.getAttribute('style')) el.removeAttribute('style');
    });
  }

  /* -------------------------------------------------------------------- 3 */

  function basliklariGeriKazan(icerik) {
    var adaylar = icerik.querySelectorAll('p');
    var sayac = 0;
    Array.prototype.forEach.call(adaylar, function (p) {
      if (sayac >= MAX_YUKSELTME) return;
      if (p.querySelector('img, table, a')) return;
      var t = metin(p);
      if (!baslikGibiMi(t)) return;

      var h = document.createElement('h2');
      while (p.firstChild) h.appendChild(p.firstChild);
      p.parentNode.replaceChild(h, p);
      sayac++;
    });
    return sayac;
  }

  /* -------------------------------------------------------------------- 4 */

  function tablolariSar(icerik) {
    icerik.querySelectorAll('table').forEach(function (tablo) {
      if (tablo.parentNode && tablo.parentNode.classList.contains('naar-sayfa__tablo')) return;
      var kutu = document.createElement('div');
      kutu.className = 'naar-sayfa__tablo';
      kutu.setAttribute('tabindex', '0');
      kutu.setAttribute('role', 'region');
      kutu.setAttribute('aria-label', 'Tablo, yatay kaydırılabilir');
      tablo.parentNode.insertBefore(kutu, tablo);
      kutu.appendChild(tablo);
    });
  }

  /* -------------------------------------------------------------------- 5 */

  function gorselleriDenetle(icerik) {
    icerik.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      // Eski sitenin kalıntı yolları ve "görsel ekle" yer tutucuları
      if (/\/class\/INNOVAEditor\//i.test(src) || /placeholder\.com|placehold\.(it|co)/i.test(src)) {
        img.setAttribute('data-nsy-kirik', 'yer-tutucu');
        return;
      }
      if (img.complete && img.naturalWidth === 0) {
        img.setAttribute('data-nsy-kirik', 'yuklenemedi');
      } else {
        img.addEventListener('error', function () {
          img.setAttribute('data-nsy-kirik', 'yuklenemedi');
        }, { once: true });
      }
    });
  }

  /* -------------------------------------------------------------------- 6 */

  function icindekilerKur(kok, icerik) {
    var yuva = kok.querySelector('[data-nsy-icindekiler]');
    if (!yuva) return;

    var basliklar = Array.prototype.filter.call(
      icerik.querySelectorAll('h2, h3'),
      function (h) { return metin(h).length > 1; }
    );

    if (basliklar.length < 3) {
      yuva.remove();
      return;
    }

    var liste = document.createElement('ol');
    var kullanilan = {};

    basliklar.forEach(function (h) {
      var t = metin(h);
      var id = h.id;
      if (!id) {
        id = slug(t);
        if (kullanilan[id]) id = id + '-' + (++kullanilan[id]);
        else kullanilan[id] = 1;
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = t.replace(/:$/, '');
      if (h.tagName === 'H3') a.setAttribute('data-alt', '');
      li.appendChild(a);
      liste.appendChild(li);
    });

    yuva.appendChild(liste);
    yuva.hidden = false;

    /* Masaustunde yapiskan kenar sutunu oldugu icin acik, dar ekranda yer
       kaplamasin diye kapali. Kullanici bir kez dokunduysa karari korunur. */
    var mq = window.matchMedia('(min-width: 1024px)');
    var dokunuldu = false;

    function esitle() {
      if (dokunuldu) return;
      if (mq.matches) yuva.setAttribute('open', '');
      else yuva.removeAttribute('open');
    }

    yuva.querySelector('summary').addEventListener('click', function () {
      dokunuldu = true;
    });

    esitle();
    if (mq.addEventListener) mq.addEventListener('change', esitle);

    okumaTakibi(liste, basliklar);
  }

  function okumaTakibi(liste, basliklar) {
    if (!('IntersectionObserver' in window)) return;
    var baglar = liste.querySelectorAll('a');
    var aktif = null;

    function isaretle(id) {
      if (aktif === id) return;
      aktif = id;
      baglar.forEach(function (a) {
        if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    var gorunur = new Set();
    var gozlemci = new IntersectionObserver(function (girisler) {
      girisler.forEach(function (g) {
        if (g.isIntersecting) gorunur.add(g.target);
        else gorunur.delete(g.target);
      });
      var ilk = basliklar.filter(function (h) { return gorunur.has(h); })[0];
      if (ilk) isaretle(ilk.id);
    }, { rootMargin: '-12% 0px -70% 0px', threshold: 0 });

    basliklar.forEach(function (h) { gozlemci.observe(h); });
  }

  /* -------------------------------------------------------------------- 7 */

  function kartlaraBol(icerik) {
    var cocuklar = Array.prototype.slice.call(icerik.children);
    var gruplar = [];
    var giris = [];
    var suanki = null;

    cocuklar.forEach(function (el) {
      if (/^H[23]$/.test(el.tagName)) {
        suanki = { baslik: el, govde: [] };
        gruplar.push(suanki);
      } else if (suanki) {
        suanki.govde.push(el);
      } else {
        giris.push(el);
      }
    });

    if (gruplar.length < 2) return false;

    var izgara = document.createElement('div');
    izgara.className = 'naar-sayfa__kartlar';

    gruplar.forEach(function (g) {
      var kart = document.createElement('article');
      kart.className = 'naar-sayfa__kart';
      kart.appendChild(g.baslik);
      g.govde.forEach(function (el) { kart.appendChild(el); });
      izgara.appendChild(kart);
    });

    if (giris.length) {
      var girisKutu = document.createElement('div');
      girisKutu.className = 'naar-sayfa__giris';
      giris.forEach(function (el) { girisKutu.appendChild(el); });
      icerik.appendChild(girisKutu);
    }

    icerik.appendChild(izgara);
    return true;
  }

  /* -------------------------------------------------------------------- 8 */

  var IBAN = /TR\s?\d{2}(?:\s?\d{4}){5}\s?\d{2}/g;

  function ibanKopyala(icerik) {
    if (!navigator.clipboard) return;

    var yuruyucu = document.createTreeWalker(icerik, NodeFilter.SHOW_TEXT, null);
    var hedefler = [];
    var d;
    while ((d = yuruyucu.nextNode())) {
      IBAN.lastIndex = 0;
      if (IBAN.test(d.nodeValue)) hedefler.push(d);
    }

    hedefler.forEach(function (dugum) {
      var deger = (dugum.nodeValue.match(IBAN) || [])[0];
      if (!deger) return;
      var sade = deger.replace(/\s+/g, '');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'naar-sayfa__kopyala';
      btn.textContent = 'Kopyala';
      btn.setAttribute('aria-label', 'IBAN numarasını kopyala');

      btn.addEventListener('click', function () {
        navigator.clipboard.writeText(sade).then(function () {
          btn.textContent = 'Kopyalandı';
          btn.setAttribute('data-kopyalandi', '');
          setTimeout(function () {
            btn.textContent = 'Kopyala';
            btn.removeAttribute('data-kopyalandi');
          }, 2000);
        });
      });

      var kap = dugum.parentNode;
      if (!kap) return;
      kap.appendChild(btn);
    });
  }

  /* ------------------------------------------------------------- başlatma */

  function baslat() {
    var kok = document.querySelector('[data-naar-sayfa]');
    if (!kok) return;

    /* main-page bolumunde icerik admin'den gelir ve .naar-sayfa__icerik
       icindedir. naar-bilgi bolumunde ise icerik temanin kendisinde, blok
       blok yazilmistir; orada temizlemeye gerek yok ama IBAN kopyalama ve
       tablo sarmalama yine calismali. */
    var icerik = kok.querySelector('.naar-sayfa__icerik');
    var statik = !icerik;
    if (statik) icerik = kok;

    var duzen = kok.getAttribute('data-duzen') || 'sade';
    var temizlensinMi = !statik && kok.getAttribute('data-temiz') === 'evet';
    var baslik = kok.getAttribute('data-baslik') || '';

    try {
      if (statik) {
        tablolariSar(icerik);
        ibanKopyala(icerik);
        return;
      }

      // Boş düğüm ve tekrar eden başlık temizliği her sayfada güvenli:
      // görünmeyen düğümleri siler, kelimelere dokunmaz.
      temizle(icerik, baslik);

      // Başlık yükseltme yalnız yapıştırılmış uzun belgelerde — sezgisel bir
      // kural olduğu için kapsamı dar tutuluyor.
      if (temizlensinMi) stilleriAyikla(icerik);
      if (temizlensinMi && duzen === 'belge') {
        basliklariGeriKazan(icerik);
        kopyaBasligiKaldir(icerik, baslik);
      }

      tablolariSar(icerik);
      gorselleriDenetle(icerik);

      if (duzen === 'belge') icindekilerKur(kok, icerik);
      if (duzen === 'bilgi') kartlaraBol(icerik);

      ibanKopyala(icerik);
    } catch (e) {
      // İçerik beklenmedik biçimdeyse sayfa yine de okunabilir kalsın
      console.warn('[naar-sayfa]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
